module.exports = __webpack_public_path__ + "static/media/s3.131a708d.png";